import React, { PropTypes } from 'react'
import NavLink from '../router/NavLink'
import MultiLangText from '../multilang/MultiLangText'

class WorkThumb extends React.Component {


  constructor(){
    super();

    let randomId = 'workThumb'+Math.round(Math.random()*10000);

    this.state={
      open: false,
      randomId
    }

    this.openItem = this.openItem.bind(this)
    this.sendPostionToParent = this.sendPostionToParent.bind(this)

  }



  openItem(){

      this.setState({open:true});

  }

  sendPostionToParent(){

    //console.log("Thumb",this);
    this.props.thumbnailOnClickPosition(this.refs.thumb)

    this.openItem();
  }


  render () {

      //console.log("Work Thumb",this);

      let active = false;


      let featureImageStyle = {
          backgroundImage: `url('${this.props.acf.hero_image.url}')`
      }

      let featureImageMonotoneStyle = {
          //backgroundImage: `url('${this.props.acf.hero_image_monotone.url}')`
          backgroundImage: `url('${this.props.acf.hero_image_monotone.sizes.medium_square}')`
      }


      if(window.innerWidth < 1025){

        featureImageStyle = {
            backgroundImage: `url('${this.props.acf.hero_image.sizes.medium_square}')`
        }
      }

      //console.log("Link Image",this.props.acf.hero_image_monotone.sizes.medium_square);

      let openClass = (this.state.open)? 'open' : 'closed';

      let highLightBrandClass = (this.props.acf.sub_title.highlight)? 'high-light' : ''



      let lang = 'en'
      //let subtitle = this.props.acf.sub_title[lang]


      //this.props.acf.title_with_breaks |
      let titleObj =  {en:this.props.title.rendered};

      if(this.props.acf.title_with_breaks){

        for(let i in this.props.acf.title_with_breaks){
          if(this.props.acf.title_with_breaks[i]){
              titleObj = this.props.acf.title_with_breaks
              //console.log("Found a title",titleObj);
          }
        }

      }

      //

      //console.log('titleObj',titleObj);

      return (
          <div className={"link-thumb"} ref="thumb" id={this.state.randomId}>
                <div className="feature-image" onClick={this.openItem}>
                  <div className="photo monotone" style={featureImageMonotoneStyle}></div>
                  <div className="photo clear" style={featureImageStyle}></div>
                  <div className="text">
                    <div className="inner-text">
                          <h5 className="title" ><MultiLangText text={titleObj} /></h5>
                          <div className={"brand "+(highLightBrandClass)} ><MultiLangText text={this.props.acf.sub_title} /></div>
                    </div>
                  </div>
                </div>

                <NavLink className="thumb-link" to={"/work/"+this.props.slug} onClick={this.sendPostionToParent} />


          </div>
      )

  }
}

export default WorkThumb;



// WEBPACK FOOTER //
// ./src/modules/work/WorkThumb.js